<template>
  <div class="book">
    <Header />
    <Nav />
    <div class="book-form">
      <img src="../assets/book/title.png" alt="">
      <div class="book-form-content">
        <div class="book-form-desc">
          <i>*</i>
          <span>请输入一下信息查询证书有效性：</span>
        </div>
        <div class="book-form-input">
          <span>证书编号：</span>
          <input type="text" placeholder="请输入15位证书编号">
        </div>
        <div class="book-form-input">
          <span>学员姓名：</span>
          <input type="text" placeholder="请输入学员姓名">
        </div>
        <div class="book-form-btn" @click="alertFlag=true">查询</div>
      </div>
    </div>
    <div class="book-class">
      <div class="book-class-title">
        <h4>发证课程</h4>
      </div>
      <div class="book-class-more">
        <span>更多</span>
      </div>
    </div>
    <div class="book-list">
      <dl>
        <dt><img src="../assets/icon/class1.png" /></dt>
        <dd>
          <h5><span>采购</span>《关于进一步加强房屋建筑和市政基础设施工程招标投…</h5>
          <p>讲师：张晟阳 宏云机构 | 28课时</p>
          <div class="book-list-time">
            <div class="left">
              <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
              <b>精品课</b>
            </div>
            <div class="right">
              <b><i>￥</i>399</b>
            </div>
          </div>
        </dd>
      </dl>
      <dl>
        <dt><img src="../assets/icon/class2.png" /></dt>
        <dd>
          <h5><span>采购</span>《关于进一步加强房屋建筑和市政基础设施工程招标投…</h5>
          <p>讲师：张晟阳 宏云机构 | 28课时</p>
          <div class="book-list-time">
            <div class="left">
              <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
              <b>精品课</b>
            </div>
            <div class="right">
              <b><i>￥</i>399</b>
            </div>
          </div>
        </dd>
      </dl>
      <dl>
        <dt><img src="../assets/icon/class3.png" /></dt>
        <dd>
          <h5><span>采购</span>《关于进一步加强房屋建筑和市政基础设施工程招标投…</h5>
          <p>讲师：张晟阳 宏云机构 | 28课时</p>
          <div class="book-list-time">
            <div class="left">
              <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
              <b>精品课</b>
            </div>
            <div class="right">
              <b><i>￥</i>399</b>
            </div>
          </div>
        </dd>
      </dl>
      <dl>
        <dt><img src="../assets/icon/class3.png" /></dt>
        <dd>
          <h5><span>采购</span>《关于进一步加强房屋建筑和市政基础设施工程招标投…</h5>
          <p>讲师：张晟阳 宏云机构 | 28课时</p>
          <div class="book-list-time">
            <div class="left">
              <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
              <b>精品课</b>
            </div>
            <div class="right">
              <b><i>￥</i>399</b>
            </div>
          </div>
        </dd>
      </dl>
    </div>
    <div class="book-list m25">
      <dl>
        <dt><img src="../assets/icon/class5.png" /></dt>
        <dd>
          <h5><span>采购</span>《关于进一步加强房屋建筑和市政基础设施工程招标投…</h5>
          <p>讲师：张晟阳 宏云机构 | 28课时</p>
          <div class="book-list-time">
            <div class="left">
              <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
              <b>精品课</b>
            </div>
            <div class="right">
              <b><i>￥</i>399</b>
            </div>
          </div>
        </dd>
      </dl>
      <dl>
        <dt><img src="../assets/icon/class6.png" /></dt>
        <dd>
          <h5><span>采购</span>《关于进一步加强房屋建筑和市政基础设施工程招标投…</h5>
          <p>讲师：张晟阳 宏云机构 | 28课时</p>
          <div class="book-list-time">
            <div class="left">
              <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
              <b>精品课</b>
            </div>
            <div class="right">
              <b><i>￥</i>399</b>
            </div>
          </div>
        </dd>
      </dl>
      <dl>
        <dt><img src="../assets/icon/class7.png" /></dt>
        <dd>
          <h5><span>采购</span>《关于进一步加强房屋建筑和市政基础设施工程招标投…</h5>
          <p>讲师：张晟阳 宏云机构 | 28课时</p>
          <div class="book-list-time">
            <div class="left">
              <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
              <b>精品课</b>
            </div>
            <div class="right">
              <b><i>￥</i>399</b>
            </div>
          </div>
        </dd>
      </dl>
      <dl>
        <dt><img src="../assets/icon/class6.png" /></dt>
        <dd>
          <h5><span>采购</span>《关于进一步加强房屋建筑和市政基础设施工程招标投…</h5>
          <p>讲师：张晟阳 宏云机构 | 28课时</p>
          <div class="book-list-time">
            <div class="left">
              <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
              <b>精品课</b>
            </div>
            <div class="right">
              <b><i>￥</i>399</b>
            </div>
          </div>
        </dd>
      </dl>
    </div>
    <div class="book-alert" v-show="alertFlag">
      <div class="book-alert-container">
        <div class="book-alert-close" @click="alertFlag=false"><img src="../assets/book/close.svg" alt=""></div>
        <h4>查询结果</h4>
        <ul>
          <li><span>证书编号：</span><b>YK2012010103737373</b></li>
          <li><span>学员姓名：</span><b>金小琦</b></li>
          <li><span>发行时间：</span><b>2022-10-27</b></li>
          <li><span>学习课程：</span><b>《关于2018年纠正医药购销和医疗服务中不正之风专项治理工作要点》解读</b></li>
        </ul>
        <div class="book-alert-btn">确定</div>
      </div>
    </div>
    <Fixed/>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import Fixed from "../components/Fixed.vue";
export default {
  name: "Book",
  components: {
    Header,
    Nav,
    Footer,
    Fixed
  },
  data() {
    return {
      alertFlag: false
    }
  }
};
</script>

<style lang="less" scoped>
.book {
  &-form {
    width: 1300px;
    height: 681px;
    margin: 12px auto 0;
    background: url(../assets/book/bg.png) no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    img {
      display: block;
      width: 397px;
      margin: 135px auto 0;
    }
    &-content {
      width: 340px;
      margin: 0 auto;
      margin-top: 55px;
    }
    &-desc {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 17px;
      i {
        color: #b6141a;
        font-style: normal;
      }
      span {
        color: #202429;
      }
    }
    &-input {
      width: 340px;
      height: 44px;
      background: rgba(255, 255, 255, 0.6);
      border-radius: 4px;
      border: 1px solid #b8b8b8;
      margin-top: 19px;
      display: flex;
      align-items: center;
      span {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000;
        line-height: 22px;
        text-indent: 16px;
      }
      input {
        background: transparent;
        margin-left: 7px;
      }
    }
    &-btn {
      width: 310px;
      height: 46px;
      background: linear-gradient(180deg, #dc2d38 0%, #b6141a 100%);
      text-align: center;
      line-height: 46px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      border-radius: 4px;
      margin: 0 auto;
      margin-top: 47px;
      cursor: pointer;
    }
  }
  &-class {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 52px;
    margin-bottom: 16px;
    &-title {
      h4 {
        font-size: 21px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 29px;
      }
    }
    &-more {
      width: 98px;
      height: 36px;
      background: #f6f8fb;
      border-radius: 18px;
      text-align: center;
      span {
        font-size: 14px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #000000;
        line-height: 36px;
      }
    }
  }
  &-list {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    dl {
      width: 310px;
      dt {
        line-height: 0;
        img {
          width: 310px;
          height: 180px;
        }
      }
      dd {
        padding: 0 12px;
        border: 1px solid #eeeeee;
        box-sizing: border-box;
        margin-top: -1px;
        padding-top: 17px;
        h5 {
          font-size: 17px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 27px;
          span {
            display: inline-block;
            width: 40px;
            height: 20px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 20px;
            background: #ff6154;
            border-radius: 2px;
            text-align: center;
          }
        }
        p {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 19px;
          margin-top: 8px;
        }
      }
    }
    &-time {
      padding-top: 18px;
      margin: 17px 0;
      border-top: 1px solid #eee;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        display: flex;
        align-items: center;
        img {
          width: 15px;
          height: 15px;
        }
        span {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 19px;
          margin-left: 2px;
          i {
            font-style: normal;
            color: #ff8243;
          }
        }
        b {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 19px;
        }
      }
      .right {
        u {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 19px;
          text-decoration: line-through;
          padding-right: 4px;
        }
        b {
          font-size: 24px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ff1d00;
          line-height: 24px;
          i {
            font-size: 15px;
            font-style: normal;
          }
        }
      }
    }
  }
  &-alert {
    background: rgba(10,10,10,0.4);
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 11;
    &-close {
      width: 40px;
      height: 40px;
      position: absolute;
      top: -54px;
      right: -40px;
      cursor: pointer;
      img {
        width: 40px;
        height: 40px;
      }
    }
    &-container {
      width: 662px;
      height: 468px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: url(../assets/book/alertbg.png) no-repeat;
      background-size: 100% 100%;
    }
    h4 {
      font-size: 36px;
      font-family: FZCSJW--GB1-0, FZCSJW--GB1;
      font-weight: normal;
      color: #97743C;
      line-height: 42px;
      margin-top: 80px;
      text-align: center;
    }
    ul {
      width: 320px;
      margin: 19px auto 0;
      li {
        display: flex;
        align-items: flex-start;
        margin-bottom: 12px;
        span {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #202429;
          line-height: 25px;
          width: 5em;
        }
        b {
          flex: 1;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #97743C;
          line-height: 25px;
          display: inline-block;
        }
      }
    }
    &-btn {
      width: 104px;
      height: 32px;
      background: linear-gradient(90deg, #FD441F 0%, #E1251B 100%);
      border-radius: 2px;
      border: 1px solid #E1251B; 
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 32px;
      text-align: center;
      margin: 40px auto 0;
      cursor: pointer;
    }
  }
}
.m25 {
  margin-top: 25px;
}
</style>